// This component will contain all the logic and the API calls related to the OBS card results
import {
  BookingStatusEnum,
  DiningFlowEntryPoint,
  ErrorManagerCodeEnum,
  OBSTypesEnum,
} from '@msc-b2c/interfaces/enums';
import {
  MyMscExcursion,
  OBSI,
  ObsResultsContainerProps,
  ShopOBSPassengerI,
} from '@msc-b2c/interfaces/interfaces';
import { Icon, PostBookingCard, Text, TooltipNew } from '@msc-b2c/shared-components';
import styles from './CardResultsContainer.module.scss';
import {
  chunkArray,
  getAlreadyBookedPassengerId,
  getCardImage,
  getCardsPerRowForViewport,
  getDisplayButton,
  getNamesOfAlreadyBookedPassengers,
  getPackageNameLabelObsBasedOnType,
  getPassengerIdsInCartForItemInCabin,
  getPostBookingCardPrices,
  hasPassengerSelectionExcludingPassengerIds,
  isItemNotFullyBooked,
  isNoEligiblePassengersForOBS,
  isReservationAvailable,
} from '../utils/PostBookingResultsUtilities';
import { getLinkedMinorObs } from '../utils/allInclusiveCmsHelpers';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  AppDispatch,
  defaultPillsVisibility,
  findPageByCode,
  getAvailablePrice,
  getCurrencyCode,
  getDemData,
  getObsBaseImagePath,
  getObsPlaceholderImagePath,
  handleScrollForDEM,
  isLayerMyAreaExcursionOpen,
  mscGet,
  mscRemove,
  myAreaShopOBS,
  RootState,
  selectedMyAreaExcursionCard,
  selectedMyAreaOBSCard,
  setErrorManagerCode,
  specialtyRestaurants,
  toggleDisplayOverlay,
  updateCartItems,
} from '@msc-b2c/shared-utils';
import Passengers from '../components/drawercontent-subcomponents/Passengers';
import {
  CartItem,
  DiningSelectionMetadata,
  ObsDrawerContentKey,
  OBSObjI,
  PillConfigurations,
} from '@msc-b2c/interfaces/types';
import { triggerAddToCartEvent, triggerViewItemEvent } from '../../utils/myAreaAnalytics';
import { useDispatch, useSelector } from 'react-redux';
import ImageTitle from '../components/drawercontent-subcomponents/ImageTitle';
import CarParkingInput from '../components/drawercontent-subcomponents/CarParkingInput';
import { CannotBookPopUp } from '../components/drawercontent-subcomponents/CannotBookPopUp';
import {
  buildObsShopRequestKey,
  getAllShopOBSData,
  getCabinIdOfTheLoggedUser,
  getShopOBSData,
} from '../../utils/myAreaUtils';
import { createRequestGuard } from '../../utils/requestGuardUtils';
import { filterPills } from '../../utils/pillManagementUtils';
import { extractTooltipContent } from '../utils/TooltipUtilities';
import { Drawer } from '../../drawer/Drawer';
import {
  addAllIncItemAndRelatedItemToCart,
  addDiningItemToCart,
  addToCart,
  hasAllInclusiveOrCombinedInBooking,
  hasAllInclusiveOrCombinedInCart,
} from '../../utils/myAreaCartUtils';
import { navigateOrRedirectToRoute } from '../../navigationmenu/utils/navigationMenuUtils';
import AddToCartOverview from '../components/drawercontent-subcomponents/AddToCartOverview';
import { useNavigate } from 'react-router-dom';
import { ErrorModal } from '../../errormodal/ErrorModal';
import { DiningMultistepDrawer } from '../components/drawercontent-subcomponents/flowtypes/DiningMultistepDrawer';
import { defineItemListName } from '../../utils/analyticsUtils';

function ObsResultsContainer({
  postBookingWrapperID,
  ObsResultsAEMProps,
  PlanMyCruiseData,
  paginatedCards,
  cardPillConfigurations,
  booking,
  modalTitle,
  modalBodyText,
  modalButtonLabel,
  currentPage,
  setCurrentPage,
  allCards,
  cardsPerResult,
  section,
}: Readonly<ObsResultsContainerProps>) {
  const { buttonLabel, obsSecondaryType } = ObsResultsAEMProps;
  const {
    alreadyBookedLabel,
    perAdultLabel,
    perCabinLabel,
    perChildLabel,
    perPackageLabel,
    myPlanButtonLabel,
    myPlanButtonDiningLabel,
    myPlanAlreadyPurchasedButtonLabel,
    promotionPriceEnabled,
    showSinglePromotionPrice,
    allInclusiveInCartErrorTitle,
    allInclusiveInCartErrorDescription,
    allInclusiveInCartErrorButtonText,
  } = PlanMyCruiseData;

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const urlCountry = getObsBaseImagePath() || '/content/dam/msc-cruises/b2c-assets/obs';
  const [cardsPerRow, setCardsPerRow] = useState<number>(
    getCardsPerRowForViewport(window.innerWidth)
  );

  const [triggerAddToCart, setTriggerAddToCart] = useState<boolean>(false);
  const [passengersToAdd, setPassengersToAdd] = useState<Record<
    string,
    Record<string, boolean>
  > | null>(null);
  const [diningSelectionToAdd, setDiningSelectionToAdd] = useState<DiningSelectionMetadata | null>(
    null
  );

  const { cabinDetails, membershipData } = useSelector((state: RootState) => state.myCruise);
  const specialityRestaurantsFromCf = useSelector(
    (state: RootState) => state.myAreaCommonConfig.specialtyRestaurants
  );

  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [shopRequestToRestaurants, setShopRequestToRestaurants] = useState<boolean>(false);

  const drawerAEMConfig = useSelector((state: RootState) => state.myAreaCommonConfig.drawerProps);
  const drawerPillConfigurations = useSelector(
    (state: RootState) => state.myAreaCommonConfig.drawerProps.drawerPillConfigurations
  );
  const drawerExcursionAEMConfig = useSelector(
    (state: RootState) => state.myAreaCommonConfig?.drawerExcursionProps?.drawerExcursionType
  );
  const myAreaOBSCardData = useSelector(
    (state: RootState) => state.myAreaDrawers.selectedMyAreaOBSCard
  );
  const confirmationDrawerProps = useSelector(
    (state: RootState) => state.myAreaCommonConfig.confirmationDrawerProps
  );
  const drawerPrice = useSelector((state: RootState) => state.myAreaDrawers.drawerPrice);
  const isLayerExcursionOpen = useSelector(
    (state: RootState) => state.myAreaDrawers.isLayerMyAreaExcursionOpen
  );
  const categoryOrder = useSelector((state: RootState) => state.myAreaCommonConfig.categoryOrder);
  const myAreaExcursionCardData = useSelector(
    (state: RootState) => state.myAreaDrawers.selectedMyAreaExcursionCard
  );
  const allOBS = useSelector((state: RootState) => state.myCruise.obs?.onboardServices);
  const allInclusiveCmsItems = useSelector(
    (state: RootState) => state.myCruise.allInclusiveCmsItems
  );
  const shopOBS = useSelector((state: RootState) => state.myCruise.shopOBS);
  const myAreaPillsVisibilityConfig = useSelector(
    (state: RootState) => state.myAreaCommonConfig.pillsVisibility[postBookingWrapperID]
  );
  const cartItems = useSelector((state: RootState) => state.myAreaCart.items);
  const myAreaPillsVisibility = myAreaPillsVisibilityConfig ?? defaultPillsVisibility;
  const { alreadyPurchasedSectionRouteMapping } = useSelector(
    (state: RootState) => state.navigationMenuData
  );

  const bannerRef = useRef<HTMLDivElement | null>(null);
  const blueBannerElement = useRef<HTMLElement | null>(null);

  const [carParkingInput, setCarParkingInput] = useState<{ model: string; plate: string }>({
    model: '',
    plate: '',
  });
  const [isOptModalOpen, setIsOptModalOpen] = useState<boolean>(false);
  const [isDrawerProcessing, setIsDrawerProcessing] = useState<boolean>(false);
  const [isConfirmationDrawer, setIsConfirmationDrawer] = useState(false);
  const [allPassengersInCart, setAllPassengersInCart] = useState(false);
  const [isAllInclusiveInCartErrorModalOpen, setIsAllInclusiveInCartErrorModalOpen] =
    useState<boolean>(false);
  // Guards duplicate opens and parallel taps for the same OBS card.
  const obsRequestGuardRef = useRef(createRequestGuard<OBSI>());

  const cardResultContainerRef = useRef<HTMLDivElement>(null);

  const [demData, setDemData] = useState<{ type: string; code: string; page: number } | null>(null);

  const activeCabinId = useMemo(() => {
    return getCabinIdOfTheLoggedUser(booking);
  }, [booking]);

  const bookingHasAllInclusiveOrCombined = useMemo(
    () => hasAllInclusiveOrCombinedInBooking(booking, allOBS),
    [booking, allOBS]
  );

  const cartHasAllInclusiveOrCombined = useMemo(
    () => hasAllInclusiveOrCombinedInCart(cartItems, allOBS),
    [cartItems, allOBS]
  );

  const shouldRenderAllInclusiveInCartErrorModal =
    Boolean(allInclusiveInCartErrorTitle) && Boolean(allInclusiveInCartErrorButtonText);

  useEffect(() => {
    if (passengersToAdd && triggerAddToCart && myAreaOBSCardData) {
      let updatedCart: CartItem[] = [];
      const promoBadges = (analyticsPillsMap[myAreaOBSCardData?.code ?? ''] ?? [])
        .map((badge) => badge.pillLabel?.toLowerCase().trim() ?? '')
        .join(':');
      const itemCategory2 = myAreaOBSCardData?.type?.code
        ? alreadyPurchasedSectionRouteMapping
            ?.find((routeItem) =>
              Object.keys(routeItem.routeTypes).includes(myAreaOBSCardData.type.code)
            )
            ?.routeLabel.toLowerCase()
        : '';
      const itemListName = defineItemListName(myAreaOBSCardData, { itemCategory2 });
      if (myAreaOBSCardData && hasRelatedPackages(myAreaOBSCardData) && shopOBS && allOBS?.length) {
        updatedCart = addAllIncItemAndRelatedItemToCart(
          shopOBS,
          allOBS,
          myAreaOBSCardData,
          promoBadges,
          itemListName
        );
      } else {
        const carParkInfo =
          myAreaOBSCardData?.type?.code === 'PARK'
            ? {
                plate: carParkingInput.plate,
                model: carParkingInput.model,
              }
            : undefined;
        if (myAreaOBSCardData?.type?.code === OBSTypesEnum.RESTAURANTS) {
          updatedCart = addDiningItemToCart(
            myAreaOBSCardData,
            passengersToAdd,
            diningSelectionToAdd ?? {
              entryPoint: DiningFlowEntryPoint.PRODUCT_CARD,
            },
            promoBadges,
            itemListName
          );
        } else {
          updatedCart = addToCart(myAreaOBSCardData, passengersToAdd, carParkInfo, {
            promoBadges,
            itemListName,
          });
        }
      }
      dispatch(updateCartItems(updatedCart));
      setTriggerAddToCart(false);
      setDiningSelectionToAdd(null);
      if (confirmationDrawerProps?.showConfirmationDrawer) {
        setIsConfirmationDrawer(true);
      } else {
        resetDrawerState();
      }
    }
  }, [
    allOBS,
    carParkingInput.model,
    carParkingInput.plate,
    confirmationDrawerProps?.showConfirmationDrawer,
    dispatch,
    diningSelectionToAdd,
    myAreaOBSCardData,
    passengersToAdd,
    shopOBS,
    triggerAddToCart,
  ]);

  const activeDrawerCard = isLayerExcursionOpen ? myAreaExcursionCardData : myAreaOBSCardData;
  const passengerIdsInCartForActiveCard = useMemo(() => {
    if (!activeDrawerCard || !booking) {
      return new Set<string>();
    }

    return getPassengerIdsInCartForItemInCabin(activeDrawerCard, cartItems, booking, activeCabinId);
  }, [activeDrawerCard, activeCabinId, booking, cartItems]);

  const hasNewPassengersToAdd = hasPassengerSelectionExcludingPassengerIds(
    passengersToAdd,
    passengerIdsInCartForActiveCard
  );

  const canAddToCartInPostBooking = myAreaOBSCardData && passengersToAdd && hasNewPassengersToAdd;

  const resetDrawerState = () => {
    // Reset only visual drawer state; do not reset request guard to preserve
    // no-refetch behavior when the same card is reopened right after close.
    setIsDrawerOpen(false);
    setIsDrawerProcessing(false);
    setIsConfirmationDrawer(false);
    setPassengersToAdd(null);
    setDiningSelectionToAdd(null);
    setCarParkingInput({ model: '', plate: '' });
    toggleDisplayOverlay(false);
    setAllPassengersInCart(false);
    dispatch(isLayerMyAreaExcursionOpen(false));
    dispatch(selectedMyAreaExcursionCard(null));
    dispatch(selectedMyAreaOBSCard(null));
  };

  const renderTooltip = (longDescription?: string): JSX.Element | null => {
    const tooltipContent = extractTooltipContent(longDescription);
    if (!tooltipContent) {
      return null;
    }

    return (
      <div className="additional-notes-container">
        <Text
          text={drawerAEMConfig.tooltipLabel}
          styleOption={'body-default'}
          tagHtml={'span'}
        />
        <TooltipNew
          appliedCssClassNames="default-text"
          triggerAriaLabel={drawerAEMConfig.tooltipLabel}
          content={
            <Text
              text={tooltipContent}
              styleOption={'body-xsmall'}
            />
          }
          positionStyle="top"
        >
          <div>
            <Icon
              icon={drawerAEMConfig.tooltipIcon}
              ariaHidden={true}
            />
          </div>
        </TooltipNew>
      </div>
    );
  };

  const getDrawerContent = (order: ObsDrawerContentKey[]): (JSX.Element | null)[] => {
    const components: Record<ObsDrawerContentKey, JSX.Element | null> = {
      [ObsDrawerContentKey.IMAGE_TITLE]: (
        <ImageTitle
          key={'image-title'}
          postBookingWrapperID={postBookingWrapperID}
          imageCode={myAreaOBSCardData?.code ?? ''}
          booking={booking}
        />
      ),
      [ObsDrawerContentKey.PASSENGERS]: (
        <Passengers
          isDrawerOpen={isDrawerOpen}
          setPassengersToAdd={setPassengersToAdd}
          hidePassengersInCart
          onAllPassengersInCartChange={setAllPassengersInCart}
          isNoEligible={isNoEligiblePassengersForOBS(
            myAreaOBSCardData,
            shopOBS,
            activeCabinId,
            booking
          )}
          beforeLongDescription={
            <CarParkingInput
              carParkingModelValue={carParkingInput.model}
              setCarParkingModel={(val: string) =>
                setCarParkingInput((prev) => ({ ...prev, model: val }))
              }
              carParkingPlate={carParkingInput.plate}
              setCarParkingPlate={(val: string) =>
                setCarParkingInput((prev) => ({ ...prev, plate: val }))
              }
            />
          }
          showGeneralHeadsUp
        />
      ),
      [ObsDrawerContentKey.CAR_PARKING_INPUT]: (
        <CarParkingInput
          carParkingModelValue={carParkingInput.model}
          setCarParkingModel={(val: string) =>
            setCarParkingInput((prev) => ({ ...prev, model: val }))
          }
          carParkingPlate={carParkingInput.plate}
          setCarParkingPlate={(val: string) =>
            setCarParkingInput((prev) => ({ ...prev, plate: val }))
          }
        />
      ),
      [ObsDrawerContentKey.ADDITIONAL_NOTES_TOOLTIP]: renderTooltip(
        myAreaOBSCardData?.longDescription ?? myAreaExcursionCardData?.longDescription
      ),
    };

    return order.map((key) => components[key]);
  };

  function mergeOBSResults(results: OBSI[], baseCard: OBSObjI): OBSI {
    if (!results.length) return {} as OBSI;

    const base = { ...results[0] };
    base.prices = {
      total: { beforeDiscount: '0', afterDiscount: '0' },
      taxes: { beforeDiscount: '0', afterDiscount: '0' },
      perPassenger: [],
    };

    const passengerMap = new Map<string, ShopOBSPassengerI>();

    const parsePrice = (str?: string) => (str ? parseFloat(str) : 0);

    results.forEach((obs) => {
      base.prices.total.beforeDiscount = (
        parsePrice(base.prices.total.beforeDiscount) + parsePrice(obs.prices.total.beforeDiscount)
      ).toString();
      base.prices.total.afterDiscount = (
        parsePrice(base.prices.total.afterDiscount) + parsePrice(obs.prices.total.afterDiscount)
      ).toString();

      base.prices.taxes.beforeDiscount = (
        parsePrice(base.prices.taxes.beforeDiscount) + parsePrice(obs.prices.taxes.beforeDiscount)
      ).toString();
      base.prices.taxes.afterDiscount = (
        parsePrice(base.prices.taxes.afterDiscount) + parsePrice(obs.prices.taxes.afterDiscount)
      ).toString();

      obs.prices.perPassenger.forEach((passenger) => {
        if (!passenger.id) return;

        if (!passengerMap.has(passenger.id)) {
          passengerMap.set(passenger.id, {
            ...passenger,
            ...(passenger.isApplicable && { relatedItemCode: obs.code }),
          });
        } else {
          const existing = passengerMap.get(passenger.id);

          if (!existing) return;

          existing.total = existing.total || {
            beforeDiscount: '0',
            afterDiscount: '0',
            beforePromotionAndDiscount: '0',
          };
          existing.total.beforeDiscount = (
            parsePrice(existing.total.beforeDiscount) + parsePrice(passenger.total?.beforeDiscount)
          ).toString();
          existing.total.afterDiscount = (
            parsePrice(existing.total.afterDiscount) + parsePrice(passenger.total?.afterDiscount)
          ).toString();

          const existingBeforePromo = existing.total.beforePromotionAndDiscount || '0';
          const passengerBeforePromo =
            passenger.total?.beforePromotionAndDiscount ?? passenger.total?.beforeDiscount;
          existing.total.beforePromotionAndDiscount = passengerBeforePromo
            ? (parsePrice(existingBeforePromo) + parsePrice(passengerBeforePromo)).toString()
            : existingBeforePromo;

          existing.taxes = existing.taxes || { beforeDiscount: '0', afterDiscount: '0' };
          existing.taxes.beforeDiscount = (
            parsePrice(existing.taxes.beforeDiscount) + parsePrice(passenger.taxes?.beforeDiscount)
          ).toString();
          existing.taxes.afterDiscount = (
            parsePrice(existing.taxes.afterDiscount) + parsePrice(passenger.taxes?.afterDiscount)
          ).toString();
          existing.relatedItemCode = passenger.isApplicable ? obs.code : existing.relatedItemCode;
          existing.isApplicable = existing.isApplicable || passenger.isApplicable;
        }
      });
    });

    base.prices.perPassenger = Array.from(passengerMap.values());

    base.code = baseCard.code ?? base.code;
    base.deliveryDate = baseCard.deliveryDate ?? base.deliveryDate;

    return base;
  }

  const hasRelatedPackages = (card: OBSObjI): boolean => {
    return (
      (card.prepaidItems?.serviceCodes?.adults?.length ?? 0) > 0 ||
      (card.prepaidItems?.serviceCodes?.minors?.length ?? 0) > 0
    );
  };

  const getObsOverviewItems = (card: OBSObjI | null): OBSObjI[] => {
    if (!card) return [];
    const relatedCodesFromCart = cartItems
      .filter((item) => item.relatedItemCode === card.code)
      .map((item) => item.code)
      .filter((code): code is string => Boolean(code));

    const relatedItems = relatedCodesFromCart
      .map((code) => allOBS?.find((obs) => obs.code === code))
      .filter((item): item is OBSObjI => Boolean(item));

    return [card, ...relatedItems];
  };

  const handleShopRequest = (
    card: OBSObjI,
    index: number | undefined,
    extraData?: {
      promoBadges?: PillConfigurations[];
      itemCategory2?: string;
    }
  ) => {
    const requestKey = buildObsShopRequestKey(card);
    const hasForfaiType = requestKey.includes('FORFAI');

    if (hasForfaiType) {
      setShopRequestToRestaurants(true);
    }

    obsRequestGuardRef.current.run(
      requestKey,
      () => getShopOBSData(card),
      (res) => {
        dispatch(myAreaShopOBS(res));
        triggerViewItemEvent(
          { ...card, index },
          booking,
          { ...extraData, shopResponse: res },
          cabinDetails,
          membershipData
        );
      }
    );
  };

  const handleMultipleShopRequest = (
    card: OBSObjI,
    index: number | undefined,
    extraData?: {
      promoBadges?: PillConfigurations[];
      itemCategory2?: string;
    }
  ) => {
    const existingCodes = allOBS?.map((obs) => obs.code ?? '') || [];

    getAllShopOBSData(card, existingCodes).then((allOBSResults) => {
      // Merge the results and sum prices as before
      const mergedResult = mergeOBSResults(allOBSResults, card);
      dispatch(myAreaShopOBS(mergedResult));
      triggerViewItemEvent(
        { ...card, index },
        booking,
        { ...extraData, shopResponse: mergedResult },
        cabinDetails,
        membershipData
      );
    });
  };

  const checkForDEM = useCallback(() => {
    if (!demData) return;

    const { code, type } = demData;

    if (!code && !type) return;
    if (!new Set(section?.split(',')).has(type)) {
      return;
    }
    mscRemove('session', 'demLogin');

    const targetPage = findPageByCode(code, allCards, cardsPerResult);

    if (targetPage !== currentPage) {
      setCurrentPage(targetPage);
      return;
    }

    const card = (indexedCardGroups ?? [])
      .flatMap((group: (OBSObjI | MyMscExcursion)[]) => group)
      .find((c: OBSObjI | MyMscExcursion) => code === c.code);

    setTimeout(() => {
      handleScrollForDEM(demData);
    }, 10);

    if (!card) {
      if (!!code) {
        dispatch(setErrorManagerCode(ErrorManagerCodeEnum.ITEM_NOT_FOUND));
      }
      setDemData(null);
      return;
    }

    if (!isReservationAvailable(card, false, booking, activeCabinId)) {
      setDemData(null);
      return;
    }

    const passengers = getAlreadyBookedPassengerId(card, booking, true, true);
    const isDrawerEnabled = getDisplayButton(passengers, booking, activeCabinId);

    if (!isDrawerEnabled) {
      setDemData(null);
      return;
    }

    const analyticsPills = analyticsPillsMap[card.code ?? ''] ?? [];
    handleCardClick(card as OBSObjI, card.index ?? 0, analyticsPills);

    setDemData(null);
  }, [demData, currentPage, allCards, cardsPerResult, booking, activeCabinId]);

  useEffect(() => {
    if (!demData) return;

    checkForDEM();
  }, [demData, checkForDEM]);

  // after the promiseAll I have to combine all the prices for each passenger with another function to return a single object
  useEffect(() => {
    if (!!mscGet<string>('session', 'demLogin')) {
      setDemData(getDemData(allCards, cardsPerResult));
    }
    const updateLayout = () => {
      setCardsPerRow(getCardsPerRowForViewport(window.innerWidth));
    };

    updateLayout();
    window.addEventListener('resize', updateLayout);

    return () => window.removeEventListener('resize', updateLayout);
  }, []);

  const filteredPillsMap = useMemo<Record<string, PillConfigurations[]>>(() => {
    const map: Record<string, PillConfigurations[]> = {};
    paginatedCards?.forEach((card) => {
      if (card.code) {
        map[card.code] = filterPills(
          card,
          cardPillConfigurations,
          myAreaPillsVisibility,
          categoryOrder,
          booking,
          cartItems
        );
      }
    });
    return map;
  }, [
    paginatedCards,
    cardPillConfigurations,
    myAreaPillsVisibility,
    categoryOrder,
    booking,
    cartItems,
  ]);

  const analyticsPillsMap = useMemo<Record<string, PillConfigurations[]>>(() => {
    const map: Record<string, PillConfigurations[]> = {};
    paginatedCards?.forEach((card) => {
      if (card.code) {
        map[card.code] = filterPills(
          card,
          drawerPillConfigurations,
          myAreaPillsVisibility,
          categoryOrder,
          booking,
          cartItems
        );
      }
    });
    return map;
  }, [
    paginatedCards,
    drawerPillConfigurations,
    myAreaPillsVisibility,
    categoryOrder,
    booking,
    cartItems,
  ]);

  // sort the cards putting last the obs with booked pillType
  // recalculate sort only if paginatedCards, filteredPillsMap change
  const sortedPaginatedCards = useMemo(() => {
    return [...(paginatedCards ?? [])].sort((cardItemA, cardItemB) => {
      // take the pilltype from filteredPillsMap based on items code
      const aPills = filteredPillsMap[cardItemA.code ?? ''] ?? [];
      const bPills = filteredPillsMap[cardItemB.code ?? ''] ?? [];

      const ObsItemA = aPills.some(
        (pill) => pill.pillType?.toUpperCase() === BookingStatusEnum.BOOKED
      );
      const ObsItemB = bPills.some(
        (pill) => pill.pillType?.toUpperCase() === BookingStatusEnum.BOOKED
      );
      // if we have obsA = obsB keep order
      // else sort keeping booked at the end
      return ObsItemA === ObsItemB ? 0 : ObsItemA ? 1 : -1;
    });
  }, [paginatedCards, filteredPillsMap]);

  const cardGroups = chunkArray(sortedPaginatedCards, cardsPerRow);

  useEffect(() => {
    if (cardResultContainerRef.current) {
      const closestPrepaidContainer = (cardResultContainerRef.current as HTMLDivElement).closest(
        '.prepaidcardcontainer'
      );

      blueBannerElement.current ??= closestPrepaidContainer?.querySelector(
        '.cmp-prepaidcardcontainer .cardWrapper .experience-fragment'
      ) as HTMLElement;

      if (blueBannerElement.current && bannerRef.current) {
        bannerRef.current.innerHTML = '';
        bannerRef.current.appendChild(blueBannerElement.current);
      }
    }
  }, [paginatedCards]);

  let isAllIncItem = false;
  let bookedPassengers: string[] = [];

  let globalIndex = 1;
  const indexedCardGroups = cardGroups?.map((cards: OBSObjI[]) =>
    cards.map((card) => {
      return {
        ...card,
        index: globalIndex++,
      };
    })
  );

  const handleCardClick = (
    card: OBSObjI,
    index: number,
    filteredPills: PillConfigurations[],
    itemCategory2?: string
  ) => {
    if (booking.status.code === BookingStatusEnum.OPTIONAL) {
      setIsOptModalOpen(true);
      document.body.classList.add('-overlay');
      return;
    }
    setAllPassengersInCart(false);
    setIsDrawerOpen(true);
    dispatch(isLayerMyAreaExcursionOpen(false));
    dispatch(selectedMyAreaExcursionCard(null));
    const viewItemExtraData = { promoBadges: filteredPills, itemCategory2 };
    hasRelatedPackages(card)
      ? handleMultipleShopRequest(card, index + 1, viewItemExtraData)
      : handleShopRequest(card, index + 1, viewItemExtraData);
    dispatch(selectedMyAreaOBSCard(card));
  };

  const getCardButtonLabel = (card: OBSObjI, bookedPassengers: string[]) => {
    const isRestaurantsType = card.type?.code === OBSTypesEnum.RESTAURANTS;
    const isProductInCart = cartItems.some(
      (item) => item.code === card.code || item.relatedItemCode === card.code
    );

    if (
      isRestaurantsType &&
      myPlanButtonDiningLabel &&
      getDisplayButton(bookedPassengers, booking, activeCabinId) &&
      (bookedPassengers.length > 0 || isProductInCart)
    ) {
      return myPlanButtonDiningLabel;
    }

    if (getDisplayButton(bookedPassengers, booking, activeCabinId) && bookedPassengers.length > 0) {
      return myPlanAlreadyPurchasedButtonLabel || buttonLabel || myPlanButtonLabel;
    }

    return buttonLabel || myPlanButtonLabel;
  };

  return (
    <div
      className={styles.cardResultsContainer}
      ref={cardResultContainerRef}
    >
      {indexedCardGroups?.map((cardGroup: OBSObjI[], index: number) => (
        <div
          key={`${index}-${cardGroup?.[0].code}`}
          className={
            index === (indexedCardGroups?.length ?? 0) - 1
              ? `${styles.cardResultsRow} ${styles.cardResultsRowLast}`
              : styles.cardResultsRow
          }
        >
          {cardGroup.map((card: OBSObjI, idx: number) => {
            isAllIncItem =
              Boolean(card?.prepaidItems?.isAllInclusive) ||
              card?.type?.code === OBSTypesEnum.BEVERAGES;
            bookedPassengers = getAlreadyBookedPassengerId(card, booking, false);
            const bookedPassengersAllCabins = getAlreadyBookedPassengerId(
              card,
              booking,
              false,
              true
            );

            const filteredPills = filteredPillsMap[card.code ?? ''] ?? [];
            const analyticsPills = analyticsPillsMap[card.code ?? ''] ?? [];
            const cardIndex = (currentPage - 1) * cardsPerResult + cardsPerRow * index + idx;
            const cardTypeCode = card?.type?.code;
            const itemCategory2 = cardTypeCode
              ? alreadyPurchasedSectionRouteMapping
                  ?.find((routeItem) => Object.keys(routeItem.routeTypes).includes(cardTypeCode))
                  ?.routeLabel.toLowerCase()
              : '';

            const canDisplayCardButton = getDisplayButton(
              bookedPassengersAllCabins,
              booking,
              activeCabinId
            );
            const linkedMinorCard = getLinkedMinorObs(card, allOBS, allInclusiveCmsItems);
            const priceSectionProps =
              card.prepaidItems?.isPerCouple ||
              card.type.code === 'PHOTO' ||
              card.type.code === 'LAUNDR'
                ? {
                    card,
                    promotionPriceEnabled,
                    showSinglePromotionPrice: true,
                    perCabinLabel: perPackageLabel,
                    perAdultLabel: perPackageLabel,
                    perChildLabel: perPackageLabel,
                  }
                : {
                    card,
                    promotionPriceEnabled,
                    showSinglePromotionPrice,
                    perCabinLabel,
                    perAdultLabel,
                    perChildLabel,
                    linkedMinorCard,
                  };

            return (
              <PostBookingCard
                key={card.code ?? idx}
                id={card?.code ?? ''}
                image={getCardImage(card, urlCountry) ?? ''}
                title={card.description ?? ''}
                imageCode={card?.code ?? ''}
                imageType="obs"
                displayedPills={filteredPills}
                placeholderImagePath={getObsPlaceholderImagePath()}
                onClick={() => handleCardClick(card, cardIndex, analyticsPills, itemCategory2)}
                clickDisabled={
                  (card?.type?.code !== OBSTypesEnum.RESTAURANTS &&
                    !isReservationAvailable(card, false, booking, activeCabinId)) ||
                  !canDisplayCardButton
                }
              >
                <PostBookingCard.PreTitle
                  text={
                    obsSecondaryType.length > 1
                      ? getPackageNameLabelObsBasedOnType(card?.type?.code, obsSecondaryType)
                      : `${obsSecondaryType[0].packageNameLabel}`
                  }
                />
                <PostBookingCard.Title packageTitle={card.description ?? ''} />
                {alreadyBookedLabel && bookedPassengers.length > 0 && !isAllIncItem && (
                  <PostBookingCard.Description
                    descriptionItems={[
                      {
                        descriptionLabel: alreadyBookedLabel,
                        descriptionValue: getNamesOfAlreadyBookedPassengers(
                          bookedPassengers,
                          booking
                        ),
                      },
                    ]}
                  />
                )}
                <PostBookingCard.PriceSection
                  prices={
                    isItemNotFullyBooked(bookedPassengersAllCabins, booking, activeCabinId)
                      ? getPostBookingCardPrices(priceSectionProps)
                      : []
                  }
                  buttonLabel={getCardButtonLabel(card, bookedPassengers)}
                  displayButton={canDisplayCardButton}
                />
              </PostBookingCard>
            );
          })}
          {index === 0 && (
            <div className={styles.blueBannerContainer}>
              <div ref={bannerRef}></div>
            </div>
          )}
        </div>
      ))}
      {!isConfirmationDrawer &&
        (myAreaOBSCardData?.type?.code === OBSTypesEnum.RESTAURANTS ? (
          <DiningMultistepDrawer
            isDrawerOpen={isDrawerOpen}
            onClose={resetDrawerState}
            booking={booking}
            flowConfig={{ entryPoint: DiningFlowEntryPoint.PRODUCT_CARD }}
            preserveSelectionGoingBack={true}
            onConfirmPassengers={(passengers, _currentStep, diningSelection) => {
              setPassengersToAdd(passengers);
              setDiningSelectionToAdd(diningSelection ?? null);
            }}
            onApply={() => {
              setTriggerAddToCart(true);
              setIsDrawerProcessing(true);
              const activeCard = isLayerExcursionOpen ? myAreaExcursionCardData : myAreaOBSCardData;
              triggerAddToCartEvent(
                activeCard,
                booking,
                cabinDetails,
                getCurrencyCode(),
                getAvailablePrice(drawerPrice),
                {
                  promoBadges: analyticsPillsMap[activeCard?.code ?? ''] ?? [],
                  itemCategory2:
                    !isLayerExcursionOpen && activeCard.type?.code
                      ? alreadyPurchasedSectionRouteMapping
                          ?.find((routeItem) =>
                            Object.keys(routeItem.routeTypes).includes(activeCard.type.code)
                          )
                          ?.routeLabel.toLowerCase()
                      : '',
                  passengersToAdd,
                },
                membershipData
              );
            }}
            setIsConfirmationDrawer={() => setIsConfirmationDrawer(true)}
            postBookingWrapperID={postBookingWrapperID}
          />
        ) : (
          <Drawer
            key={'drawer'}
            postBookingWrapperID={postBookingWrapperID}
            closeIcon={drawerAEMConfig.closeDrawerIcon}
            firstButtonLabel={drawerExcursionAEMConfig?.addToCartButtonLabel}
            limitedSeatsPlaceholder={drawerAEMConfig.limitedSeatsPlaceholder}
            secondButtonLabel=""
            alreadyInCartMessageLabel={
              allPassengersInCart ? drawerAEMConfig.alreadyInCartMessageLabel : ''
            }
            alreadyInCartCtaLabel={allPassengersInCart ? drawerAEMConfig.alreadyInCartCtaLabel : ''}
            alreadyInCartCtaLink={
              allPassengersInCart ? drawerAEMConfig.alreadyInCartCtaLink : undefined
            }
            processingFirstButtonLabel={drawerExcursionAEMConfig?.addingToCartButtonLabel}
            processingFirstButtonIcon={drawerExcursionAEMConfig?.addingToCartButtonIcon}
            isDrawerOpen={isDrawerOpen}
            enableClosingByClickingOutside={true}
            disabled={
              myAreaOBSCardData?.type?.code === 'PARK'
                ? !canAddToCartInPostBooking ||
                  !carParkingInput.model.trim() ||
                  !carParkingInput.plate.trim()
                : !canAddToCartInPostBooking
            }
            onClose={resetDrawerState}
            onApply={() => {
              const isAllIncOrCombinedCard = !!myAreaOBSCardData?.prepaidItems?.isAllInclusive;

              if (
                isAllIncOrCombinedCard &&
                (bookingHasAllInclusiveOrCombined || cartHasAllInclusiveOrCombined)
              ) {
                toggleDisplayOverlay(false);
                setIsDrawerProcessing(false);
                setIsAllInclusiveInCartErrorModalOpen(true);
                return;
              }

              toggleDisplayOverlay(false);
              setTriggerAddToCart(true);
              setIsDrawerProcessing(true);
              const activeCard = isLayerExcursionOpen ? myAreaExcursionCardData : myAreaOBSCardData;
              triggerAddToCartEvent(
                activeCard,
                booking,
                cabinDetails,
                getCurrencyCode(),
                getAvailablePrice(drawerPrice),
                {
                  promoBadges: analyticsPillsMap[activeCard?.code ?? ''] ?? [],
                  itemCategory2:
                    !isLayerExcursionOpen && activeCard?.type?.code
                      ? alreadyPurchasedSectionRouteMapping
                          ?.find((routeItem) =>
                            Object.keys(routeItem.routeTypes).includes(activeCard?.type.code)
                          )
                          ?.routeLabel.toLowerCase()
                      : '',
                  passengersToAdd,
                },
                membershipData
              );
            }}
            stylingOption="transparent-header"
            isProcessing={isDrawerProcessing}
            hiddenFooter={isNoEligiblePassengersForOBS(
              myAreaOBSCardData,
              shopOBS,
              activeCabinId,
              booking
            )}
          >
            <>
              {getDrawerContent([
                ObsDrawerContentKey.IMAGE_TITLE,
                ObsDrawerContentKey.PASSENGERS,
                ...(!drawerAEMConfig?.disableAdditionalNotesTooltip
                  ? [ObsDrawerContentKey.ADDITIONAL_NOTES_TOOLTIP]
                  : []),
              ])}
            </>
          </Drawer>
        ))}
      {isConfirmationDrawer && (
        <Drawer
          postBookingWrapperID={postBookingWrapperID}
          title={confirmationDrawerProps?.title}
          titleIcon={confirmationDrawerProps?.titleIcon}
          closeIcon={drawerAEMConfig.closeDrawerIcon}
          firstButtonLabel={confirmationDrawerProps?.continueShoppingButtonLabel}
          secondButtonLabel={confirmationDrawerProps?.viewCartButtonLabel}
          isDrawerOpen={isDrawerOpen}
          enableClosingByClickingOutside={true}
          onClose={resetDrawerState}
          onClear={() => {
            resetDrawerState();
            navigateOrRedirectToRoute(confirmationDrawerProps?.viewCartLink || {}, navigate);
          }}
          onApply={resetDrawerState}
          stylingOption="confirmation-drawer"
          footerButtonsVariant={'secondary'}
        >
          <div className="add-to-cart-overview-list">
            {(() => {
              // Combined adult + minor ALLINC packages render as a single merged card.
              const [primaryItem, ...relatedItems] = getObsOverviewItems(myAreaOBSCardData);
              return primaryItem ? (
                <AddToCartOverview
                  postBookingCard={primaryItem}
                  relatedCards={relatedItems}
                  passengersToAdd={passengersToAdd}
                />
              ) : null;
            })()}
          </div>
        </Drawer>
      )}
      {isAllInclusiveInCartErrorModalOpen && shouldRenderAllInclusiveInCartErrorModal && (
        <ErrorModal
          title={allInclusiveInCartErrorTitle ?? ''}
          message={allInclusiveInCartErrorDescription ?? ''}
          styleOption="-all-inclusive-in-cart-modal"
          ctaLabel={allInclusiveInCartErrorButtonText ?? ''}
          handleClosure={() => setIsAllInclusiveInCartErrorModalOpen(false)}
          handleClick={() => setIsAllInclusiveInCartErrorModalOpen(false)}
        />
      )}
      {isOptModalOpen && (
        <CannotBookPopUp
          modalTitle={modalTitle}
          modalBodyText={modalBodyText}
          modalButtonLabel={modalButtonLabel}
          handleClose={() => {
            document.body.classList.remove('-overlay');
            setIsOptModalOpen(false);
          }}
          handleClick={() => {
            document.body.classList.remove('-overlay');
            setIsOptModalOpen(false);
          }}
        />
      )}
    </div>
  );
}

export default ObsResultsContainer;
